module.exports = __webpack_public_path__ + "img/map_1791445710923_27700.1d0ca2c7.gif";